(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bm-header').forEach((header) => {
    const menuButton = header.querySelector('[data-bm-header-menu-button]');
    const nav = header.querySelector('.bm-header__nav');

    if (!menuButton || !nav) {
      return;
    }

    menuButton.addEventListener('click', () => {
      const isOpen = header.classList.toggle('bm-header--menu-open');
      menuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      menuButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    });

    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        header.classList.remove('bm-header--menu-open');
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.setAttribute('aria-label', 'Open menu');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-home-hero"] && !Shopify.designMode) return;
  try {
    
  const getHomeLayers = () => Array.from(document.querySelectorAll('[data-bm-home-layer], .shopify-section-group-footer-group'));
  const initialHomeLayers = getHomeLayers();

  if (initialHomeLayers.length > 1) {
    let activeLayer = 0;
    let isLocked = false;
    let touchStartY = 0;
    let headerFadeTimeout;
    const headerFadeMs = 200;

    const updateHeaderSpace = () => {
      const headerParts = Array.from(document.querySelectorAll('.bm-announcement, .bm-header'));
      const headerBottom = headerParts.reduce((largestBottom, element) => {
        const rectangle = element.getBoundingClientRect();
        return Math.max(largestBottom, rectangle.bottom);
      }, 0);

      if (headerBottom > 0) {
        document.documentElement.style.setProperty('--bm-home-header-space', `${Math.ceil(headerBottom)}px`);
      }
    };

    const updateHeaderStyle = (isSolid, animate = true) => {
      window.clearTimeout(headerFadeTimeout);

      if (!animate) {
        document.body.classList.toggle('bm-home-header-solid', isSolid);
        document.body.classList.remove('bm-home-header-fading');
        return;
      }

      document.body.classList.add('bm-home-header-fading');

      headerFadeTimeout = window.setTimeout(() => {
        document.body.classList.toggle('bm-home-header-solid', isSolid);

        window.requestAnimationFrame(() => {
          document.body.classList.remove('bm-home-header-fading');
        });
      }, headerFadeMs);
    };

    const updateLayer = (index, animateHeader = true) => {
      const homeLayers = getHomeLayers();

      activeLayer = Math.max(0, Math.min(homeLayers.length - 1, index));

      homeLayers.forEach((layer, layerIndex) => {
        layer.style.transform = layerIndex <= activeLayer ? 'translate3d(0, 0, 0)' : 'translate3d(0, 100%, 0)';
        layer.style.pointerEvents = layerIndex === activeLayer ? 'auto' : 'none';
        layer.setAttribute('aria-hidden', layerIndex === activeLayer ? 'false' : 'true');
      });

      updateHeaderStyle(activeLayer > 0, animateHeader);
    };

    const moveLayer = (direction) => {
      if (isLocked) {
        return;
      }

      const homeLayers = getHomeLayers();
      const nextLayer = Math.max(0, Math.min(homeLayers.length - 1, activeLayer + direction));

      if (nextLayer === activeLayer) {
        return;
      }

      isLocked = true;
      updateLayer(nextLayer, true);

      window.setTimeout(() => {
        isLocked = false;
      }, 720);
    };

    window.addEventListener(
      'wheel',
      (event) => {
        if (!document.body.classList.contains('template-index')) {
          return;
        }

        event.preventDefault();

        if (Math.abs(event.deltaY) < 12) {
          return;
        }

        moveLayer(event.deltaY > 0 ? 1 : -1);
      },
      { passive: false }
    );

    window.addEventListener(
      'touchstart',
      (event) => {
        touchStartY = event.touches[0]?.clientY || 0;
      },
      { passive: true }
    );

    window.addEventListener(
      'touchend',
      (event) => {
        if (!document.body.classList.contains('template-index')) {
          return;
        }

        const touchEndY = event.changedTouches[0]?.clientY || 0;
        const distance = touchStartY - touchEndY;

        if (Math.abs(distance) < 40) {
          return;
        }

        moveLayer(distance > 0 ? 1 : -1);
      },
      { passive: true }
    );

    window.addEventListener('keydown', (event) => {
      if (!document.body.classList.contains('template-index')) {
        return;
      }

      if (event.key === 'ArrowDown' || event.key === 'PageDown' || event.key === ' ') {
        event.preventDefault();
        moveLayer(1);
      }

      if (event.key === 'ArrowUp' || event.key === 'PageUp') {
        event.preventDefault();
        moveLayer(-1);
      }
    });

    window.addEventListener('resize', updateHeaderSpace);
    updateHeaderSpace();
    updateLayer(activeLayer, false);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-product-accordion-image"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bm-product-accordion-image__item').forEach((item) => {
    const summary = item.querySelector('.bm-product-accordion-image__summary');
    const panel = item.querySelector('.bm-product-accordion-image__panel');

    if (!summary || !panel) {
      return;
    }

    if (item.open) {
      panel.style.height = 'auto';
    }

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (item.dataset.animating === 'true') {
        return;
      }

      item.dataset.animating = 'true';

      if (!item.open) {
        item.open = true;
        panel.style.height = '0px';

        requestAnimationFrame(() => {
          panel.style.height = `${panel.scrollHeight}px`;
        });

        panel.addEventListener(
          'transitionend',
          () => {
            panel.style.height = 'auto';
            item.dataset.animating = 'false';
          },
          { once: true }
        );

        return;
      }

      panel.style.height = `${panel.scrollHeight}px`;

      requestAnimationFrame(() => {
        panel.style.height = '0px';
      });

      panel.addEventListener(
        'transitionend',
        () => {
          item.open = false;
          item.dataset.animating = 'false';
        },
        { once: true }
      );
    });

    item.querySelectorAll('[data-ingredients-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const shortContent = item.querySelector('[data-ingredients-short]');
        const fullContent = item.querySelector('[data-ingredients-full]');

        if (!shortContent || !fullContent) {
          return;
        }

        const showFull = fullContent.hasAttribute('hidden');
        panel.style.height = `${panel.scrollHeight}px`;

        requestAnimationFrame(() => {
          shortContent.toggleAttribute('hidden', showFull);
          fullContent.toggleAttribute('hidden', !showFull);
          toggle.textContent = showFull ? toggle.dataset.fullLabel : toggle.dataset.shortLabel;
          panel.style.height = `${panel.scrollHeight}px`;
        });

        panel.addEventListener(
          'transitionend',
          () => {
            if (item.open) {
              panel.style.height = 'auto';
            }
          },
          { once: true }
        );
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-product-use-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bm-product-use-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-bm-product-use-carousel-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-bm-product-use-carousel-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-bm-product-use-carousel-dot]'));
    const dotsWrapper = carousel.querySelector('[data-bm-product-use-carousel-dots]');

    if (!track || slides.length === 0) {
      return;
    }

    const hasScrollableOverflow = () => {
      return track.scrollWidth - track.clientWidth > 8;
    };

    const setControlsVisibility = () => {
      const shouldShowControls = hasScrollableOverflow();

      if (dotsWrapper) {
        dotsWrapper.hidden = !shouldShowControls;
      }

      return shouldShowControls;
    };

    const getClosestIndex = () => {
      const trackLeft = track.getBoundingClientRect().left;
      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const scrollToSlide = (index) => {
      const slide = slides[index];

      if (!slide) {
        return;
      }

      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
    };

    const updateDots = () => {
      if (!setControlsVisibility()) {
        return;
      }

      const activeIndex = getClosestIndex();

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('bm-product-use-carousel__dot--active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        scrollToSlide(index);
      });
    });

    track.addEventListener('scroll', updateDots, { passive: true });
    window.addEventListener('resize', updateDots);
    requestAnimationFrame(updateDots);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('[data-bm-footer-localization]').forEach((form) => {
    const select = form.querySelector('[data-bm-footer-locale-select]');
    const countryInput = form.querySelector('[data-bm-footer-country-input]');
    const languageInput = form.querySelector('[data-bm-footer-language-input]');

    if (!select || !countryInput || !languageInput) {
      return;
    }

    select.addEventListener('change', () => {
      const [countryCode, languageCode] = select.value.split('|');

      countryInput.value = countryCode;
      languageInput.value = languageCode;

      form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-media-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-product-media-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-product-media-slide]'));
    const thumbnails = Array.from(carousel.querySelectorAll('[data-product-media-thumbnail]'));
    const previous = carousel.querySelector('[data-product-media-previous]');
    const next = carousel.querySelector('[data-product-media-next]');
    const stage = carousel.querySelector('.product-media__stage');
    const mobileMediaQuery = window.matchMedia('(max-width: 1199px), (hover: none) and (pointer: coarse)');
    let activeIndex = Number(carousel.dataset.initialIndex) || 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;

    if (!track || slides.length < 2) {
      return;
    }

    const pauseVideos = () => {
      carousel.querySelectorAll('video').forEach((video) => {
        video.pause();
        video.currentTime = 0;
      });
    };

    const playActiveVideo = () => {
      const activeVideo = slides[activeIndex]?.querySelector('video');

      if (!activeVideo) {
        return;
      }

      activeVideo.muted = true;
      activeVideo.currentTime = 0;
      activeVideo.play().catch(() => {});
    };

    const setActiveSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${activeIndex * 100}%)`;
      pauseVideos();

      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === activeIndex ? 'false' : 'true');
      });

      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const isActive = thumbnailIndex === activeIndex;
        thumbnail.classList.toggle('product-media__thumbnail--active', isActive);
        thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      playActiveVideo();
    };

    previous?.addEventListener('click', () => {
      setActiveSlide(activeIndex - 1);
    });

    next?.addEventListener('click', () => {
      setActiveSlide(activeIndex + 1);
    });

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const index = Number(thumbnail.dataset.index);
        setActiveSlide(index);
      });
    });

    stage?.addEventListener(
      'touchstart',
      (event) => {
        if (!mobileMediaQuery.matches) {
          return;
        }

        const touch = event.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchEndX = touchStartX;
        touchEndY = touchStartY;
      },
      { passive: true }
    );

    stage?.addEventListener(
      'touchmove',
      (event) => {
        if (!mobileMediaQuery.matches) {
          return;
        }

        const touch = event.touches[0];
        touchEndX = touch.clientX;
        touchEndY = touch.clientY;
      },
      { passive: true }
    );

    stage?.addEventListener(
      'touchend',
      () => {
        if (!mobileMediaQuery.matches) {
          return;
        }

        const horizontalDistance = touchEndX - touchStartX;
        const verticalDistance = touchEndY - touchStartY;

        if (Math.abs(horizontalDistance) < 40 || Math.abs(horizontalDistance) < Math.abs(verticalDistance)) {
          return;
        }

        setActiveSlide(activeIndex + (horizontalDistance < 0 ? 1 : -1));
      },
      { passive: true }
    );

    setActiveSlide(activeIndex);
  });

  document.querySelectorAll('[data-product-sticky-buy]').forEach((stickyBuy) => {
    const mainSubmit = document.querySelector('[data-product-main-submit]');

    if (!mainSubmit) {
      return;
    }

    const setStickyVisibility = (isVisible) => {
      stickyBuy.classList.toggle('product-sticky-buy--visible', isVisible);
      stickyBuy.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    };

    const updateStickyVisibility = () => {
      const mainSubmitRect = mainSubmit.getBoundingClientRect();
      const scrolledPastMainSubmit = mainSubmitRect.bottom < 0;
      const distanceFromPageEnd =
        document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
      const isAtPageEnd = distanceFromPageEnd < 160;

      setStickyVisibility(scrolledPastMainSubmit && !isAtPageEnd);
    };

    updateStickyVisibility();
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility);
  });

  } catch(e) { console.error(e); }
})();
})();
